import { useState, type FormEvent } from 'react'
import { useAuth } from '../auth/AuthContext'
import { Icon } from '../components/Icon'
import logoUrl from '../assets/images/logo.png'

export function LoginPage() {
  const { login } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError('')
    const result = await login(username, password)
    if (!result.ok) {
      setError(result.error)
    }
    setBusy(false)
  }

  return (
    <div className="auth">
      <div className="auth__promo">
        <div className="auth__brand">
          <img className="auth__logo" src={logoUrl} alt="My Adult Day Care" />
          <span>MyADC</span>
        </div>

        <div className="auth__promo-body">
          <h2>Care management, made calm and clear.</h2>
          <p>
            A modern workspace for your adult day care — clients, clinical records,
            transport and billing all in one place.
          </p>
          <div className="auth__points">
            <div className="auth__point">
              <Icon name="check" /> Fast client lookup across your whole roster
            </div>
            <div className="auth__point">
              <Icon name="check" /> Clean, faithful clinical charts and forms
            </div>
            <div className="auth__point">
              <Icon name="check" /> Works right inside SharePoint
            </div>
          </div>
        </div>
      </div>

      <div className="auth__panel">
        <form className="auth__form" onSubmit={onSubmit}>
          <h1>Welcome back</h1>
          <p>Sign in to continue to your dashboard.</p>

          <div className="field">
            <label htmlFor="login-user">Email</label>
            <input
              id="login-user"
              type="email"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername((e.target as HTMLInputElement).value)}
              placeholder="admin@myadc.local"
              required
            />
          </div>

          <div className="field">
            <label htmlFor="login-pass">Password</label>
            <input
              id="login-pass"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword((e.target as HTMLInputElement).value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error ? <p className="form-error">{error}</p> : null}

          <div className="auth__row">
            <label className="muted" style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
              <input type="checkbox" /> Remember me
            </label>
            <a className="btn--link" href="#/login">
              Forgot password?
            </a>
          </div>

          <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>

          {import.meta.env.DEV ? (
            <p className="auth__hint">Local account: admin@myadc.local / ChangeMe123!</p>
          ) : null}
        </form>
      </div>
    </div>
  )
}
